const Footer = () => {
  return (
    <footer className="muted-text py-8">
      &copy;2025{" "}
      <a
        href="http://github.com/hereisphil"
        target="_blank"
        rel="noopener noreferrer"
        className="text-gray-600 hover:text-gray-400"
      >
        @hereisphl
      </a>
    </footer>
  );
};
export default Footer;
